import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Skeleton from '@mui/material/Skeleton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import React, { useContext, useEffect, useState } from 'react';
import MyContext from '../../Context/AppContext';
import { Close, History } from '@mui/icons-material';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import './checkUsageModal.css';
import fetchUsageData from '../../Apis/FetchUsageData';
import { showToast } from '../../utils/toastUtils';
import configJSON from "../../Config.json";

const CheckUsageModal = () => {
    const { usageModal, setUsageModal } = useContext(MyContext);
    const [selectedEndDate, setSelectedEndDate] = useState(new Date());
    const [rows, setRows] = useState([]);
    const [tableDataLoading, setTableDataLoading] = useState(false);
    const [accountSummaryLoading, setAccountSummaryLoading] = useState(false);
    const [accountSummary, setAccountSummary] = useState({
        accountType: '',
        accountStartDate: '',
        accountValidUpto: '',
        totalJDsCreated: '',
        chatLimit: '',
        totalEncounteredChats: '',
        accountTypeInfo: {}
    });
    const getDefaultStartDate = () => {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        return oneYearAgo;
    };

    const [selectedStartDate, setSelectedStartDate] = useState(getDefaultStartDate());


    // Pagination state
    const [page, setPage] = useState(0);
    const rowsPerPage = 5;

    // Handle page change
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const fetchUsageDataHandler = async (isInitial, startDate, endDate, userId) => {
        try {
            let payload = {
                startDate: startDate,
                endDate: endDate,
                isInitial: isInitial
            }
            if (isInitial) {
                setAccountSummaryLoading(true);
            }
            setTableDataLoading(true);
            setRows([]);

            let response = await fetchUsageData(userId, payload);

            if (response?.status === 200) {
                setRows(response?.data?.usageData);
                if (isInitial) {
                    let chatLimit = response?.data?.accountInfo?.chatLimit;
                    if(response?.data?.accountInfo?.accountTypeInfo?.typecode === configJSON.ACCOUNTTYPE_PERMANENT){
                        chatLimit = 'Unlimited';
                    }
                    setAccountSummary({
                        accountType: response?.data?.accountInfo?.accountTypeInfo?.typename,
                        accountStartDate: response?.data?.accountInfo?.accountStartDate,
                        accountValidUpto: response?.data?.accountInfo?.accountValidUpto,
                        totalJDsCreated: response?.data?.accountInfo?.totalJDsCreated,
                        chatLimit: chatLimit,
                        totalEncounteredChats: response?.data?.accountInfo?.totalEncounteredChats,
                        accountTypeInfo : response?.data?.accountInfo?.accountTypeInfo
                    });
                }

            }
        } catch (error) {
            console.log(error);
            showToast('Something went wrong', 'error');
        }
        finally {
            setTableDataLoading(false);
            setAccountSummaryLoading(false);
        }
    }

    const dateChangeHandler = (date, dateType) => {
        let startDate = selectedStartDate
        let endDate = selectedEndDate
        if (dateType === 'startDate') {
            if (date > endDate) {
                setSelectedEndDate(date)
                endDate = date
            }
            setSelectedStartDate(date)
            startDate = date
        } else {
            if (date < startDate) {
                setSelectedStartDate(date)
                startDate = date
            }
            setSelectedEndDate(date)
            endDate = date
        }
        fetchUsageDataHandler(false, startDate, endDate);
    }

    const handleClose = () => {
        // setCheckUsageStatModalOpen(false);
        setUsageModal({
            isOpen: false,
            userId: null,
        });
        setRows([]);
        setSelectedStartDate(getDefaultStartDate());
        setSelectedEndDate(new Date());
    }

    useEffect(() => {
        if (usageModal?.isOpen && usageModal?.userId) {
            fetchUsageDataHandler(true, selectedStartDate, selectedEndDate,usageModal?.userId);
        }
    }, [usageModal]);


    return (
        <Dialog
            onClose={() => handleClose()}
            open={usageModal?.isOpen}
            maxWidth='md'
            fullWidth
        >
            <DialogTitle className='dialogTitle_usageDialog'>
                <div className='headerSection_usageDialog'>
                    <div className='dialogTitle'>
                        <History />
                        <span>Usage Statistics</span>
                    </div>
                    <IconButton onClick={() => handleClose()}>
                        <Close className='closeButton_usageModal' />
                    </IconButton>
                </div>
            </DialogTitle>
            <DialogContent className='usageDialogContainer'>
                <div className='contentContainer_usageDialog'>
                    <div className='topContent_usageDialog'>
                        <span className='accountSummaryTitle'>Account Summary</span>
                        <div className='accountSummaryItems'>Account Type : {accountSummaryLoading ? <CircularProgress size={20} /> : accountSummary?.accountType}</div>
                        <div className='accountSummaryItems'>Account Start Date : {accountSummaryLoading ? <CircularProgress size={20} /> : accountSummary?.accountStartDate}</div>
                        <div className='accountSummaryItems'>Account Valid Upto : {accountSummaryLoading ? <CircularProgress size={20} /> : accountSummary?.accountValidUpto}</div>
                        <div className='accountSummaryItems accountSummaryItems_last'>
                            <span>Total Job Descriptions created till date : </span>
                            {accountSummaryLoading ?
                                <CircularProgress size={20} />
                                :
                                <span>{" "+accountSummary?.totalJDsCreated}</span>
                            }
                        </div>
                        <div>
                            <span>Total Encountered Chat : </span>
                            {accountSummaryLoading ?
                                <CircularProgress size={20} />
                                :
                                <span>{" " + accountSummary?.totalEncounteredChats + " of " + accountSummary?.chatLimit}</span>
                            }
                        </div>
                    </div>
                    <hr className='hrLine_usage' />
                    <div className='usageStatsTitleContainer'>
                        <span className='accountSummaryTitle'>Usage Statistics Data</span>

                        <div className='datePickerContainer_usageDialog'>
                            <div className='datePickerDiv_usageDialog'>
                                <span>From</span>
                                <DatePicker
                                    className="datePicker_checkUsage"
                                    selected={selectedStartDate}
                                    onChange={(date) => dateChangeHandler(date, "startDate")}
                                    dateFormat="dd-MMM-yyyy"
                                    showIcon
                                    disabled={tableDataLoading}
                                />
                            </div>
                            <div className='datePickerDiv_usageDialog datePickerDiv_usageDialog_endDate'>
                                <span>To</span>
                                <DatePicker
                                    className="datePicker_checkUsage"
                                    selected={selectedEndDate}
                                    onChange={(date) => dateChangeHandler(date, "endDate")}
                                    dateFormat="dd-MMM-yyyy"
                                    showIcon
                                    maxDate={new Date()}
                                    disabled={tableDataLoading}
                                />
                            </div>

                        </div>
                    </div>


                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow className='tableHeader_usageDialog'>
                                    <TableCell align='center' className='tableCell'>MON - YYYY</TableCell>
                                    <TableCell align='center' className='tableCell'>Encountered Chat</TableCell>
                                    <TableCell align='center' className='tableCell'>JDs Created</TableCell>
                                    <TableCell align='center' className='tableCell'>Chat Started but JDs not created</TableCell>
                                </TableRow>
                            </TableHead>

                            {rows.length === 0 ?

                                tableDataLoading ?
                                    <TableBody>
                                        <TableRow>
                                            <TableCell><Skeleton animation="wave" /></TableCell>
                                            <TableCell><Skeleton animation="wave" /></TableCell>
                                            <TableCell><Skeleton animation="wave" /></TableCell>
                                            <TableCell><Skeleton animation="wave" /></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell><Skeleton animation="wave" /></TableCell>
                                            <TableCell><Skeleton animation="wave" /></TableCell>
                                            <TableCell><Skeleton animation="wave" /></TableCell>
                                            <TableCell><Skeleton animation="wave" /></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell><Skeleton animation="wave" /></TableCell>
                                            <TableCell><Skeleton animation="wave" /></TableCell>
                                            <TableCell><Skeleton animation="wave" /></TableCell>
                                            <TableCell><Skeleton animation="wave" /></TableCell>
                                        </TableRow>
                                    </TableBody>
                                    :
                                    <TableBody>
                                        <TableRow>
                                            <TableCell colSpan={4} align='center'>No Data Found</TableCell>
                                        </TableRow>
                                    </TableBody>

                                :
                                <TableBody>

                                    {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                                        <TableRow key={row.month}>
                                            <TableCell align='center'>{row.date}</TableCell>
                                            <TableCell align='center'>{row.totalHistoryCount}</TableCell>
                                            <TableCell align='center'>{row.isCreatedTrue}</TableCell>
                                            <TableCell align='center'>{row.isCreatedFalse}</TableCell>
                                        </TableRow>

                                    ))}
                                </TableBody>
                            }

                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[5]}
                            component="div"
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                        />
                    </TableContainer>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default CheckUsageModal;
